import {ChangeRequestReview} from 'src/openapi/models/ChangeRequestReview';
import {RootState} from 'src/store/store';

export const getChangeRequestReview = (
    state: RootState,
): Record<string, ChangeRequestReview> => state.changeRequestReview.data;
